var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('v-select', {
    staticClass: "mt-2",
    attrs: {
      "item-value": "id",
      "items": _vm.groups,
      "label": _vm.$t('objects.invoice.groupId'),
      "outlined": "",
      "clearable": "",
      "loading": _vm.isLoadingGroup
    },
    on: {
      "change": _vm.saveGroup,
      "click": _vm.refreshGroups
    },
    scopedSlots: _vm._u([{
      key: "append",
      fn: function fn() {
        return [_c('group-type-create-dialog', {
          attrs: {
            "partnerId": _vm.value.partnerId,
            "type": _vm.ResourceEnum.INVOICE
          },
          on: {
            "created": function created(group) {
              return _vm.value.groupId = group.id;
            }
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function fn(_ref) {
              var on = _ref.on;
              return [_c('v-btn', {
                staticStyle: {
                  "position": "relative",
                  "top": "-6px"
                },
                attrs: {
                  "icon": "",
                  "loading": _vm.isLoadingGroups
                },
                on: {
                  "click": function click($event) {
                    $event.stopPropagation();
                    return on.apply(null, arguments);
                  }
                }
              }, [_c('v-icon', [_vm._v("mdi-plus")])], 1)];
            }
          }])
        })];
      },
      proxy: true
    }, {
      key: "item",
      fn: function fn(_ref2) {
        var item = _ref2.item;
        return [_vm._v(" " + _vm._s(item.title) + " ")];
      }
    }, {
      key: "selection",
      fn: function fn(_ref3) {
        var item = _ref3.item;
        return [_vm._v(" " + _vm._s(item.title) + " ")];
      }
    }]),
    model: {
      value: _vm.value.groupId,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "groupId", $$v);
      },
      expression: "value.groupId"
    }
  }), _c('div', {
    staticClass: "mt-n7",
    staticStyle: {
      "display": "flex"
    }
  }, [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "x-small": "",
      "text": "",
      "elevation": 0,
      "loading": _vm.isLoadingGroups
    },
    on: {
      "click": _vm.refreshGroups
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("common.verbs.refresh")) + " ")]), _c('v-btn', {
    attrs: {
      "x-small": "",
      "text": "",
      "elevation": 0
    },
    on: {
      "click": _vm.goToGroupCustomView
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("common.verbs.view")) + " ")])], 1), _vm.group && _vm.group.configuration && _vm.group.configuration.customFieldConfig && _vm.group.configuration.customFieldConfig.length ? _c('div', [_vm.isLoadingCustomFieldValues ? _c('v-progress-linear', {
    attrs: {
      "indeterminate": ""
    }
  }) : _c('v-divider'), _c('custom-field-list-form', {
    staticClass: "mt-6",
    attrs: {
      "customFieldConfig": _vm.group.configuration.customFieldConfig
    },
    on: {
      "change": _vm.debounceSaveCustomFields
    },
    model: {
      value: _vm.value.values,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "values", $$v);
      },
      expression: "value.values"
    }
  })], 1) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }